import httpClient from "../http/http-client";
import {
  IDashboard,
  IPostDashboard,
  IWidgetDataRequestWidget,
  IWidgetDataResponse,
} from './dashboard.model';

export default class DashboardService {
  http;

  constructor() {
    this.http = httpClient;
  }

  async getAll(): Promise<IDashboard[]> {
    return this.http.get('dashboard')
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }

  async getOne(id: string, includeElements = false): Promise<IDashboard> {
    return this.http.get(`dashboard/${id}${includeElements ? '?includeElements=true' : ''}`)
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }

  async create(dashboard: IPostDashboard): Promise<IDashboard> {
    return this.http.post('dashboard', dashboard)
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }

  async edit(id: string, dashboard: IPostDashboard): Promise<IDashboard> {
    return this.http.patch(`dashboard/${id}`, dashboard)
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }

  async remove(id: string): Promise<{ message: string }> {
    return this.http.delete(`dashboard/${id}`)
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }

  // Batched widget data for a dashboard: one request computes every widget for the given period.
  async getWidgetData(
    reportPeriodId: string,
    widgets: IWidgetDataRequestWidget[],
    scopeTwoMethod?: 'location' | 'market',
  ): Promise<IWidgetDataResponse> {
    return this.http.post('analytics/dashboard-widget-data', { reportPeriodId, widgets, scopeTwoMethod })
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }
}
